import { render, staticRenderFns } from "./ServerBasedEnumFormField.vue?vue&type=template&id=092c85b8&"
import script from "./ServerBasedEnumFormField.vue?vue&type=script&lang=ts&"
export * from "./ServerBasedEnumFormField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports